// extracted by mini-css-extract-plugin
export default {"wrapper":"query_wrapper__p8+V5","icon":"query_icon__4QCyv","datepicker":"query_datepicker__t3LM2","linkBtn":"query_linkBtn__4MX-+"};